export default "__VITE_PUBLIC_ASSET__895d8969__"